import { type FC } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface PulseLoadingProps {
  className?: string;
}

const PulseLoading: FC<PulseLoadingProps> = ({ className }) => {
  return (
    <div className={cn(css.pulseWrapper, className)}>
      <div className={css.pulse}></div>
    </div>
  );
};

export { PulseLoading };
